import { render, staticRenderFns } from "./icon-arrow-long-rounded.vue?vue&type=template&id=2a85ef55&scoped=true&"
import script from "./icon-arrow-long-rounded.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-long-rounded.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-long-rounded.vue?vue&type=style&index=0&id=2a85ef55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85ef55",
  null
  
)

export default component.exports